(function (app) {

    app.constant("taxQualifications",
    [
        { Label: "Traditional IRA", Value: "TraditionalIra" },
        { Label: "Non-Qualified", Value: "NonQualified" },
        { Label: "Simple IRA", Value: "SimpleIra" },
        { Label: "457B", Value: "FourFiftySevenB" },
        { Label: "Roth IRA", Value: "RothIra" },
        { Label: "SEP IRA", Value: "SepIra" },
        { Label: "Inherited IRA", Value: "InheritedIra" },
        { Label: "Qualified Retirement Plan - 401K, 403B, Pension, other", Value: "QualifiedRetirementPlan" },
        { Label: "Other", Value: "Other" }
    ]);
})(window.app); //jshint ignore:line